// import React, { useState } from "react";
// import { AiOutlineDown } from "react-icons/ai";
// import '../../assets/styles/status-picker.css'; // Asegúrate de que los estilos están importados
// import { ROLES } from '../../services/user.service'; // Asegúrate de importar correctamente

// const statusOptions = [
//     { id: 5, name: "Iniciada", color: "#0073EA", textColor: "#ffffff" },
//     { id: 2, name: "En Proceso", color: "#fcab3c", textColor: "#ffffff" },
//     { id: 3, name: "Terminada", color: "#00c875", textColor: "#ffffff" },
//     { id: 1, name: "No Iniciada", color: "#df2f4a", textColor: "#ffffff" },
//     { id: 4, name: "No se realizara", color: "#4b4c6a", textColor: "#ffffff" },
// ];

// export function StatusPicker({ customHeight, info, field, onUpdate, userRol }) {
//     const [isOpen, setIsOpen] = useState(false);
//     const [selectedStatus, setSelectedStatus] = useState(info.estado);

//     // Definir si el usuario puede editar
//     const isEditable = userRol === ROLES.ADMIN || userRol === ROLES.TECNICO;

//     console.log(info.avancesDescripcion);

//     function handleStatusChange(ev, status) {
//         ev.preventDefault(); 
//         if (!isEditable) return; // Si no es editable, no hacer nada
//         setSelectedStatus(status);
//         setIsOpen(false);
//         onSave(ev, status);
//     }

//     function onSave(ev, status) {
//         onUpdate(ev, field, status);
//     }

//     const selectedOption = statusOptions.find(opt => opt.id === selectedStatus);

//     return (
//         <div className="status-picker picker" style={{alignContent:'center', height: customHeight, width:'170px'}}>
//             <div 
//                 className="selected-status" 
//                 onClick={() => isEditable && setIsOpen(!isOpen)} // Solo abrir si es editable
//                 style={{ 
//                     backgroundColor: selectedOption?.color || '#ffffff', 
//                     color: selectedOption?.textColor || '#ffffff', 
//                     height: customHeight,
//                     cursor: isEditable ? 'pointer' : 'not-allowed' // Cambiar el cursor según si es editable
//                 }}
//             >
//                 {selectedOption?.name || "Seleccionar..."}
//                 <AiOutlineDown className="dropdown-icon" />
//             </div>
//             {isOpen && (
//                 <ul className="status-options">
//                     {statusOptions.map(option => (
//                         <li 
//                             key={option.id} 
//                             onClick={(ev) => handleStatusChange(ev, option.id)} 
//                             className={option.id === selectedStatus ? "selected" : ""}
//                             style={{ backgroundColor: option.color, color: option.textColor }}
//                         >
//                             {option.name}
//                         </li>
//                     ))}
//                 </ul>
//             )}
//         </div>
//     );
// }



// StatusPicker.js
import React, { useState } from "react";
import { AiOutlineDown } from "react-icons/ai";
import '../../assets/styles/status-picker.css'; // Asegúrate de que los estilos están importados
import { ROLES } from '../../services/user.service'; // Asegúrate de importar correctamente
import NotificationModal from '../modal/notifications-modal'; // Importa el componente del modal

const statusOptions = [
    { id: 5, name: "Iniciada", color: "#0073EA", textColor: "#ffffff" },
    { id: 2, name: "En Proceso", color: "#fcab3c", textColor: "#ffffff" },
    { id: 3, name: "Terminada", color: "#00c875", textColor: "#ffffff" },
    { id: 1, name: "No Iniciada", color: "#df2f4a", textColor: "#ffffff" },
    { id: 4, name: "No se realizara", color: "#4b4c6a", textColor: "#ffffff" },
];

export function StatusPicker({ customHeight, info, field, onUpdate, userRol }) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState(info.estado);
    const [modalOpen, setModalOpen] = useState(false); // Estado para el modal
    const [modalMessage, setModalMessage] = useState('');
    const [modalType, setModalType] = useState('info'); // Tipo de alerta

    // Definir si el usuario puede editar
    const isEditable = userRol === ROLES.ADMIN || userRol === ROLES.TECNICO;

    
    
    function handleStatusChange(ev, status) {
        ev.preventDefault();
        if (!isEditable) return; // Si no es editable, no hacer nada
    
        // Obtener la opción seleccionada
        const selectedOption = statusOptions.find(opt => opt.id === status);
        if (!selectedOption) return; // Si no existe la opción seleccionada, salir
        
        if (info.campo === "task-preview") {

        // Eliminar espacios en blanco de la descripción de avances
        const avancesDescripcion = info.avancesDescripcion?.trim() || '';
    
        // Definir mensajes de advertencia
        const emptyDescriptionMessage = "No se puede modificar el estado de la ACTIVIDAD, mientras el campo DESCRIPCIÓN DE AVANCES esté vacío";
        const noFilesMessage = "No se puede modificar el estado de la ACTIVIDAD, mientras no haya archivos adjuntos.";
    
        // Validación de estado y descripción de avances
        const isRestrictedStatus = ["Terminada", "En Proceso", "No se realizara"].includes(selectedOption.name);
        if (isRestrictedStatus && avancesDescripcion.length < 50) {
            setModalMessage(emptyDescriptionMessage);
            setModalType("warning");
            setModalOpen(true);
            return; // Detener la ejecución si no cumple la validación
        }
    
        // Validación de cantidad de archivos (excepto si es "No se realizara")
        if (info.cantidadArchivos === 0 && selectedOption.name === "Terminada") {
            setModalMessage(noFilesMessage);
            setModalType("warning");
            setModalOpen(true);
            return; // Detener la ejecución si no cumple la validación
        }
    }

        setSelectedStatus(status);
        setIsOpen(false);
        onSave(ev, status);


        
    }

    function onSave(ev, status) {
        onUpdate(ev, field, status);
    }

    const selectedOption = statusOptions.find(opt => opt.id === selectedStatus);

    return (
        <div className="status-picker picker" style={{alignContent:'center', height: customHeight, width:'170px'}}>
            <div 
                className="selected-status" 
                onClick={() => isEditable && setIsOpen(!isOpen)} // Solo abrir si es editable
                style={{ 
                    backgroundColor: selectedOption?.color || '#ffffff', 
                    color: selectedOption?.textColor || '#ffffff', 
                    height: customHeight,
                    cursor: isEditable ? 'pointer' : 'not-allowed' // Cambiar el cursor según si es editable
                }}
            >
                {selectedOption?.name || "Seleccionar..."}
                <AiOutlineDown className="dropdown-icon" />
            </div>
            {isOpen && (
                <ul className="status-options">
                    {statusOptions.map(option => (
                        <li 
                            key={option.id} 
                            onClick={(ev) => handleStatusChange(ev, option.id)} 
                            className={option.id === selectedStatus ? "selected" : ""}
                            style={{ backgroundColor: option.color, color: option.textColor }}
                        >
                            {option.name}
                        </li>
                    ))}
                </ul>
            )}
            <NotificationModal open={modalOpen} onClose={() => setModalOpen(false)} message={modalMessage} type={modalType}/>
        </div>
    );
}


//---Version Original-----

// import { useRef } from "react"
// import { useSelector } from "react-redux"
// import { boardService } from "../../services/board.service"
// import { setDynamicModalObj } from "../../store/board.actions"

// export function StatusPicker({ info, onUpdate }) {
//     const dynamicModalObj = useSelector(storeState => storeState.boardModule.dynamicModalObj)
//     const board = useSelector(storeState => storeState.boardModule.board)
//     const activity = boardService.getEmptyActivity()
//     const elStatusSection = useRef()

//     let classText = !info.status ? 'empty-label ' : ''
//     classText += 'label-text'
    
//     // const label = board.labels.find(label => label.title === info.status)
//     const label = "EN PROCESO"
//     const color = label ? label.color : '#c4c4c4'
//     activity.from = label
//     activity.task = { id: info.id, title: info.title }

//     function onToggleMenuModal() {
//         const isOpen = dynamicModalObj?.task?.id === info.id && dynamicModalObj?.type === 'status' ? !dynamicModalObj.isOpen : true
//         const { x, y } = elStatusSection.current.getClientRects()[0]
//         setDynamicModalObj({ isOpen, pos: { x: (x - 35), y: (y + 38) }, type: 'status', task: info, onTaskUpdate: onUpdate, activity: activity })
//     }

//     return (
//         <section role="contentinfo" ref={elStatusSection} className="status-priority-picker picker" style={{ backgroundColor: color }} onClick={onToggleMenuModal}>
//             <div className={classText}>{info.status}</div>
//             <span className="fold"></span>
//         </section>
//     )

// }